'use client'

import s from './News.module.scss';
import {TNewsCardProps} from "@/app/[locale]/common/components/News/types";
import Image from "next/image";
import {Link} from '@/i18n/routing';
import {BUTTON_TEXTS} from "../../constants/button";
import {textAbbreviation} from "@/app/[locale]/common/utils/functions/textAbbreviation/textAbbreviation";
import {useResponsive} from "@/app/[locale]/common/utils/hooks/useResponsive/useResponsive";
import {NEWS_BREAKPOINT_FOR_TEXT_LENGTH, NEWS_MAX_TEXT_LENGTH, NEWS_MIN_TEXT_LENGTH} from "../../constants/main";
import {convertDateFormat} from "@/app/[locale]/common/utils/functions/convertDateFormat/convertDateFormat";

export const NewsCard = ({ id, title, text, date, image}: TNewsCardProps) => {
    const textLength = useResponsive(NEWS_MAX_TEXT_LENGTH, NEWS_MIN_TEXT_LENGTH, NEWS_BREAKPOINT_FOR_TEXT_LENGTH) as number;
    const formatedText = textAbbreviation(text, textLength);
    const formatedDate = convertDateFormat(date);

    return (
        <div className={s.card}>
            <Link href={`/news/${id as string}`} className={s.card_imageContainer}>
                {
                    image === null
                        ?
                            'no image'
                        :
                    <Image src={image} width={500} height={500} alt={''}/>
                }
            </Link>
            <label>{ title }</label>
            <span className={s.card_date}>{ formatedDate }</span>
            <div className={s.card_text}>
                <p>
                    { formatedText }
                    <span>
                        <Link key={date} href={`/news/${id as string}`} className={s.card_text_link}>
                            { BUTTON_TEXTS.INFO_READ_MORE }
                        </Link>
                    </span>
                </p>
            </div>
        </div>
    );
};